import { DateTime } from "luxon";
import {
  isLastUsedAuthMethod,
  LastUsedAuthMethod,
  LastUsedAuthMethodRecord,
} from "@/domains/auth/last-used-auth-method";
import { LocalStorageKey } from "@/modules/local-storage/constants";
import { objectModule } from "@/modules/object";

const isLastUsedAuthMethodRecord = (value: unknown): value is LastUsedAuthMethodRecord => {
  if (!value || typeof value !== "object") {
    return false;
  }

  const candidate = value as Partial<LastUsedAuthMethodRecord>;

  return isLastUsedAuthMethod(candidate.method) && typeof candidate.updatedAtMs === "number";
};

export const readLastUsedAuthMethod = (): LastUsedAuthMethodRecord | null => {
  try {
    const raw = localStorage.getItem(LocalStorageKey.LastUsedAuthMethod);

    if (!raw) {
      return null;
    }

    const parsed = objectModule.fromJson<unknown>(raw);

    if (!isLastUsedAuthMethodRecord(parsed)) {
      localStorage.removeItem(LocalStorageKey.LastUsedAuthMethod);
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
};

export const writeLastUsedAuthMethod = (
  method: LastUsedAuthMethod
): LastUsedAuthMethodRecord | null => {
  try {
    const record: LastUsedAuthMethodRecord = {
      method,
      updatedAtMs: DateTime.now().toMillis(),
    };

    localStorage.setItem(LocalStorageKey.LastUsedAuthMethod, JSON.stringify(record));

    return record;
  } catch {
    return null;
  }
};

export const clearLastUsedAuthMethod = (): void => {
  try {
    localStorage.removeItem(LocalStorageKey.LastUsedAuthMethod);
  } catch {
    // noop
  }
};
